<h2>{{cardConfiguration.title}}</h2>
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <label class="disabled" for="code">{{'CardServiceIdentification.Code' | translate}}</label>
      <input class="form-control" type="text" numeric="7" placeholder="{{'CardServiceIdentification.Code' | translate}}" [(ngModel)]="cardData.code" name="code" #code="ngModel"  readonly>
      <validation-message [control]="code"></validation-message>
    </div>
  </div>
  <div class="col-sm-8">
    <div class="form-group">
      <label class="disabled" for="designation">{{'CardServiceIdentification.Designation' | translate}}</label>
      <input class="form-control" placeholder="{{'CardServiceIdentification.Designation' | translate}}" [(ngModel)]="cardData.designation" name="designation" #designation="ngModel" readonly >
      <validation-message [control]="designation"></validation-message>
    </div>
  </div>
</div>
<!--<pre>{{cardData | json}}</pre>-->

